<template>
  <div class="registerIndex">
    <div class="reg-header">
      <i class="icon-back" @click="back"></i>
      <img src="@/assets/sp_logo.png" alt="" @click="home" class="logo">
      <h2 class="title">请选择您的注册类型</h2>
    </div>
    <div class="reg-main">
      <div class="reg-module">
        <h3 class="title">企业用户</h3>
        <div class="reg-item" @click="regCompany">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_1.png" alt="">
            <span class="label">企业发单客户</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_1_active.png" alt="">
              <div class="reg-dd">企业发单客户</div>
            </div>
            <p class="desc">平台匹配工单解决您的工业需求</p>
          </div>
        </div>
        <div class="reg-item" @click="regService">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_3.png" alt="">
            <span class="label">接单服务商</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_3_active.png" alt="">
              <div class="reg-dd">接单服务商</div>
            </div>
            <p class="desc">承接服务工单，赚取服务费；<br>参加速派组织的培训及考核，提升服务能力；</p>
          </div>
        </div>
      </div>
      <div class="reg-module">
        <h3 class="title">个人用户</h3>
        <div class="reg-item" @click="regUser">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_2.png" alt="">
            <span class="label">个人发单客户</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_2_active.png" alt="">
              <div class="reg-dd">个人发单客户</div>
            </div>
            <p class="desc">平台匹配工单解决您的工业需求</p>
          </div>
        </div>
        <div class="reg-item" @click="regEngineer">
          <div class="default">
            <img class="icon" src="@/assets/register/icon_4.png" alt="">
            <span class="label">接单工程师</span>
          </div>
          <div class="hover">
            <div class="reg-dl">
              <img class="icon" src="@/assets/register/icon_4_active.png" alt="">
              <div class="reg-dd">接单工程师</div>
            </div>
            <p class="desc">承接服务工单，赚取服务费；<br>参加速派组织的培训及考核，提升服务能力的同时，可以承接企业定制工单；</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-min">
        <div class="footer-content">
            <div class="insupai-link">
                <a target="_blank" href="/Help/helpCenter_01.html">关于我们</a>
                <span>Ι</span>
                <a target="_blank" href="/Help/helpCenter_02.html">联系我们</a>
                <span>Ι</span>
                <a target="_blank" href="/Help/helpCenter_01.html">帮助中心</a>
            </div>
            <div class="friends-link">
                <span>友情链接：</span>
                <a target="_blank" href="http://www.gongkong.com/" >中国工控网</a>
                <a target="_blank" href="http://www.gongkongmall.com/" >工控猫</a>
                <a target="_blank" href="http://www.gongkongedu.com/" >工控教育</a>
                <a target="_blank" href="http://www.gongkong.com/hr/index.html" >人才认证</a>
                <a target="_blank" href="http://video.gongkong.com/" >智造视频</a>
                <a target="_blank" href="http://www.shuigongye.com/" >中国水工业网</a>
                <a target="_blank" href="http://www.chinaopc.org/" >OPC中国</a>
                <a target="_blank" href="http://www.gkquan.com/" >工控圈</a>
                <a target="_blank" href="http://www.casicloud.com" >航天云网</a>
                <a target="_blank" href="http://www.gepresearch.com" >环保研究网</a>
                <a target="_blank" href="/Help/helpCenter_19.html">更多</a>
            </div>
            <div class="sp-copyright">
                <span>版权所有：Copyright&nbsp;<i>©</i>&nbsp;</span>
                <span>经营许可证编号：京B2-20190088</span>
                <span><a href="http://www.beian.miit.gov.cn">京ICP备16043380号-4</a></span>
            </div>
        </div>
    </div>
    <!-- <div class="qrcode-dialog" v-if="showQrcode" @click="showQrcode=false">
      <div class="qrcode-wrapper">
        <img class="qrcode" src="@/assets/supaiapp_ercode.png" alt="">
        <span class="desc">扫码下载工业速派app <br>即可进行工程师注册流程</span>
      </div>
    </div> -->
  </div>
</template>

<script>
// import MyDialog from '@/components/gkDialog.vue'
import {bpoAppQrcode} from '@/scripts/bpo.js'
import {mapState} from 'vuex'
import {isDev,BASEURL,p_origin,c_origin} from '@/scripts/util.js'
export default {
  name: 'contract',
  components:{
    // MyDialog
  },
  data(){
    return{
      showQrcode:false,
    }
  },
  created() {
  },
  methods: {
    back(){
      window.history.back();
    },
    home(){
      window.location.href=p_origin;
      console.log(p_origin);
    },
    regCompany(){
      window.location.href=p_origin+'/bpojob/companyRegister.html';
    },
    regService(){
      window.location.href=p_origin+'/bpojob/serviceRegister.html';
    },
    regUser(){
      window.location.href=p_origin+'/bpojob/personRegister.html';
    },
    regEngineer(){
      // this.showQrcode=true;
      bpoAppQrcode();
    },
  },
}
</script>

<style lang="scss">
@import '@/style/reset.scss';
.registerIndex{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 68px;
  background: url('~@/assets/register/bg.png') no-repeat center top;
  background-size: cover;
  .reg-header{
    width: 900px;
    height: 68px;
    margin: 0 auto 8px;
    text-align: center;
    overflow: hidden;
    background-color: #fff;
    position: relative;
    .icon-back{
      position: absolute;
      left: 0;
      top: 14px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      &:before{
        content: "";
        width: 15px;
        height: 15px;
        position: absolute;
        left: 50%;
        top: 50%;
        border-left: 2px solid #333;
        border-bottom: 2px solid #333;
        transform: rotate(45deg);
        margin-top: -10px;
      }
    }
    .logo{
      position: absolute;
      left: 40px;
      top: 15px;
      width: 131px;
      cursor: pointer;
    }
    .title{
      font-size: 20px;
      line-height: 1.5;
      font-weight: bold;
      color: #333;
      margin-top: 19px;
    }
  }
  .reg-main{
    width: 900px;
    height: 380px;
    margin: 0 auto;
    padding: 10px 60px;
    background-color: #fff;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 50%;
      top: 73px;
      width: 0;
      height: 220px;
      border-left: 1px dashed #FF7E16;
    }
  }
  .reg-module{
    float: left;
    width: 390px;
    .title{
      text-align: center;
      font-size: 20px;
      color: #333;
      line-height: 1.5;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  .reg-item{
    width: 330px;
    height: 148px;
    margin: 0 auto 15px;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    .default{
      text-align: center;
      overflow: hidden;
      .icon{
        display: block;
        width: 44px;
        height: 44px;
        margin: 40px auto 10px;
      }
      .label{
        font-size: 18px;
        color: #333;
        line-height: 48px;
        font-weight: bold;
      }
    }
    .hover{
      transition: all 0.2s linear;
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #FF822E;
      border-radius: 10px;
      padding: 11px 15px;
      &:after{
        content: "";
        position: absolute;
        right: 20px;
        top: 22px;
        width: 10px;
        height: 10px;
        border-top: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(45deg);
      }
      .reg-dl{
        overflow: hidden;
        width: 100%;
        margin-bottom: 10px;
      }
      .icon{
        float: left;
        width: 44px;
        height: 44px;
        margin-left: 6px;
        margin-right: 20px;
      }
      .reg-dd{
        font-size: 18px;
        color: #fff;
        line-height: 36px;
        font-weight: 500;
      }
      .desc{
        font-size: 14px;
        color: #fff;
        line-height: 24px;
      }
    }
    &:hover{
      box-shadow: 0px 8px 20px 0px rgba(26, 26, 26, 0.2);
      .hover{
        top: 0;
      }
    }
  }
  .footer-min{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 40px;
    text-align: center;
    a{
      font-size: 14px;
      line-height: 24px;
      color: #fff;
    }
    span,i{
      font-size: 14px;
      line-height: 24px;
      color: #fff;
    }
    .insupai-link>i{
      padding-left: 10px;
      padding-right: 10px;
    }
    .insupai-link>a,
    .friends-link>a{
      margin-left: 10px;
      margin-right: 10px;
    }

  }
  // .qrcode-dialog{
  //   position: fixed;
  //   left: 0;
  //   top: 0;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 999;
  //   background-color: rgba(0,0,0,0.6);
  //   .qrcode-wrapper{
  //     position: absolute;
  //     left: 50%;
  //     top: 50%;
  //     z-index: 999;
  //     width: 300px;
  //     height: 300px;
  //     transform: translate(-50%,-50%);
  //     border-radius: 10px;
  //     background-color: #fff;
  //     padding: 50px;
  //     text-align: center;
  //   }
  //   .qrcode{
  //     display: block;
  //     width: 142px;
  //     height: 142px;
  //     margin: 0 auto 10px;
  //   }
  //   .desc{
  //     font-size: 14px;
  //     line-height: 24px;
  //     color: #333;
  //   }
  // }
}


</style>